import { Color } from "three";

export const pixelRate = 1 / 300; /* 1 word unit is 300 pixels */

export const backgroundColor = new Color(0xffffff);
